/*
    Create by Pierre Marsot on 05/12/2017
*/
import {get, removeApi} from '../tools/api';
import {sendMessageError} from './toast';

export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'LOAD_USER_ERROR';

export const LOAD_BALISES_USER_SUCCESS = 'LOAD_BALISES_USER_SUCCESS';
export const LOAD_BALISES_USER_ERROR = 'LOAD_BALISES_USER_ERROR';

export const LOAD_INCIDENTS_USER_SUCCESS = 'LOAD_INCIDENTS_USER_SUCCESS';
export const LOAD_INCIDENTS_USER_ERROR = 'LOAD_INCIDENTS_USER_ERROR';

export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';
export const REMOVE_USER_ERROR = 'REMOVE_USER_ERROR';

function loadUserSuccess(payload){
    return {
        type: LOAD_USER_SUCCESS,
        user: payload.user,
    };
}

function loadUserError(){
    return {
        type: LOAD_USER_ERROR,
    };
}

export function loadUser(idUser) {
    return dispatch => {
        if (!idUser || idUser.length === 0) {
            dispatch(sendMessageError("erreur_recuperation_identifiant_utilisateur"));
            return dispatch(loadUserError());
        }

        get("/api/societe/users/" + idUser)
            .then((response) => {
                if (response && response.user) {
                    return dispatch(loadUserSuccess(response));
                } else {
                    dispatch(sendMessageError("erreur_recuperation_utilisateur"));
                    return dispatch(loadUserError());
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                    return dispatch(loadUserError());
                } else {
                    dispatch(sendMessageError("erreur_recuperation_utilisateur"));
                    return dispatch(loadUserError());
                }
            })
    };
}

function loadBalisesUserSuccess(payload){
    return {
        type: LOAD_BALISES_USER_SUCCESS,
        balises: payload.balises,
    };
}

function loadBalisesUserError(){
    return {
        type: LOAD_BALISES_USER_ERROR,
    };
}

export function loadBalisesUser(idUser) {
    return dispatch => {
        if (!idUser || idUser.length === 0) {
            dispatch(sendMessageError("erreur_recuperation_identifiant_utilisateur"));
            return dispatch(loadBalisesUserError());
        }

        get("/api/societe/users/" + idUser + "/balises")
            .then((response) => {
                if (response && response.balises) {
                    return dispatch(loadBalisesUserSuccess(response));
                } else {
                    dispatch(sendMessageError("erreur_recuperation_balises_utilisateur"));
                    return dispatch(loadBalisesUserError());
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                    return dispatch(loadBalisesUserError());
                } else {
                    dispatch(sendMessageError("erreur_recuperation_balises_utilisateur"));
                    return dispatch(loadBalisesUserError());
                }
            })
    };
}

function loadIncidentsUserSuccess(payload){
    return {
        type: LOAD_INCIDENTS_USER_SUCCESS,
        incidents: payload.incidents,
    };
}

function loadIncidentsUserError(){
    return {
        type: LOAD_INCIDENTS_USER_ERROR,
    };
}

export function loadIncidentsUser(idUser) {
    return dispatch => {
        if (!idUser || idUser.length === 0) {
            dispatch(sendMessageError("erreur_recuperation_identifiant_utilisateur"));
            return dispatch(loadIncidentsUserError());
        }

        get("/api/societe/users/" + idUser + "/incidents")
            .then((response) => {
                if (response && response.incidents) {
                    return dispatch(loadIncidentsUserSuccess(response));
                } else {
                    dispatch(sendMessageError("erreur_recuperation_incidents_utilisateur"));
                    return dispatch(loadIncidentsUserError());
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                    return dispatch(loadIncidentsUserError());
                } else {
                    dispatch(sendMessageError("erreur_recuperation_incidents_utilisateur"));
                    return dispatch(loadIncidentsUserError());
                }
            })
    };
}

function removeSuccess(id) {
    return {
        type: REMOVE_USER_SUCCESS,
        id: id,
    };
}

export function removeUser(id) {
    return dispatch => {
        if(!id || id.length === 0) {
            return dispatch(sendMessageError("erreur_recuperation_identifiant_utilisateur"));
        }

        removeApi("/api/societe/users/" + id)
            .then((response) => {
                return dispatch(removeSuccess(id));
            })
            .catch((response) => {
                if (response && response.error) {
                    return dispatch(sendMessageError(response.error));
                } else {
                    return dispatch(sendMessageError("erreur_suppression_utilisateur"));
                }
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/user.js